var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlZumuruda(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 161,
    viewBox: "0 0 101 161",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.7872 150.276C61.2677 150.276 70.5744 140.969 70.5744 129.488C70.5744 118.008 61.2677 108.701 49.7872 108.701C38.3067 108.701 29 118.008 29 129.488C29 140.969 38.3067 150.276 49.7872 150.276Z",
    stroke: "#CC7D61",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50 160.5C67.397 160.5 81.5 146.397 81.5 129C81.5 111.603 67.397 97.5 50 97.5C32.603 97.5 18.5 111.603 18.5 129C18.5 146.397 32.603 160.5 50 160.5Z",
    stroke: "#CC7D61"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50 138.701C55.5228 138.701 60 134.224 60 128.701C60 123.178 55.5228 118.701 50 118.701C44.4772 118.701 40 123.178 40 128.701C40 134.224 44.4772 138.701 50 138.701Z",
    fill: "#CC7D61"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7729 46.8356L50.2956 26.874L49.8184 46.8356H50.7729Z",
    fill: "url(#paint0_radial_717_1813)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M70.225 26.3965L50.2949 26.8745L70.225 27.3525V26.3965Z",
    fill: "url(#paint1_radial_717_1813)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8184 6.91309L50.2956 26.8748L50.7729 6.91309H49.8184Z",
    fill: "url(#paint2_radial_717_1813)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3652 27.3525L50.2953 26.8745L30.3652 26.3965V27.3525Z",
    fill: "url(#paint3_radial_717_1813)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8701 43.4024C52.8701 43.4749 52.8412 43.5618 52.8267 43.6342C52.6387 44.6337 52.5375 45.6622 52.5375 46.7052H52.4073C52.4073 46.7197 51.1925 35.4207 51.1925 35.4207L50.2812 26.874L51.5252 34.8847L52.8558 43.4024H52.8701Z",
    fill: "url(#paint4_radial_717_1813)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1093 24.745L58.8281 25.9618L50.2949 26.8744L58.293 25.6286L66.7973 24.2959C66.8696 24.2959 66.9564 24.3249 67.0287 24.3394C68.0266 24.5277 69.0391 24.6291 70.0949 24.6291V24.7594L70.1093 24.745Z",
    fill: "url(#paint5_radial_717_1813)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2951 26.8743L49.0513 18.8635L47.7207 10.3458C47.7207 10.2734 47.7496 10.1865 47.7641 10.114C47.9521 9.11447 48.0534 8.08597 48.0534 7.04298H48.1835C48.1835 7.0285 49.3984 18.3276 49.3984 18.3276L50.3096 26.8743H50.2951Z",
    fill: "url(#paint6_radial_717_1813)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2953 26.8749L42.2972 28.1206L33.7929 29.4533C33.7206 29.4533 33.6338 29.4244 33.5615 29.4099C32.5635 29.2216 31.5511 29.1202 30.5098 29.1202V28.9898C30.4953 28.9898 41.7765 27.773 41.7765 27.773L50.3097 26.8604L50.2953 26.8749Z",
    fill: "url(#paint7_radial_717_1813)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0553 39.6651C53.9107 39.9983 53.7661 40.3459 53.6359 40.6936L52.045 34.117L50.2949 26.874L52.3198 33.7548L54.0553 39.6796V39.6651Z",
    fill: "url(#paint8_radial_717_1813)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0927 23.5284L57.5265 25.1219L50.2949 26.8747L57.1649 24.8467L63.0803 23.1084C63.4129 23.2532 63.76 23.3981 64.1072 23.5284H64.0927Z",
    fill: "url(#paint9_radial_717_1813)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2936 26.8743L48.2688 19.9935L46.5332 14.0832C46.6778 13.75 46.8225 13.4024 46.9526 13.0547L48.5436 19.6313L50.2936 26.8888V26.8743Z",
    fill: "url(#paint10_radial_717_1813)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2947 26.874L43.4247 28.902L37.5093 30.6404C37.1767 30.4955 36.8295 30.3506 36.4824 30.2203L43.0487 28.6268L50.2802 26.874H50.2947Z",
    fill: "url(#paint11_radial_717_1813)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M55.083 37.6959C54.9673 37.8842 54.8661 38.0725 54.7504 38.2608C54.7504 38.2898 54.7215 38.3043 54.707 38.3332L52.7255 33.1907L50.2812 26.8604L52.9425 32.8865L55.0686 37.6814L55.083 37.6959Z",
    fill: "url(#paint12_radial_717_1813)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M61.736 22.4412L56.6017 24.4258L50.2812 26.8739L56.298 24.2085L61.0853 22.0791C61.2733 22.195 61.4613 22.2964 61.6493 22.4122C61.6782 22.4122 61.6926 22.4412 61.7215 22.4557L61.736 22.4412Z",
    fill: "url(#paint13_radial_717_1813)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2931 26.8744L47.6319 20.8482L45.5059 16.0534C45.6216 15.8651 45.7228 15.6768 45.8385 15.4884C45.8385 15.4595 45.8674 15.445 45.8819 15.416L47.8633 20.5585L50.3076 26.8889L50.2931 26.8744Z",
    fill: "url(#paint14_radial_717_1813)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2938 26.8749L44.2772 29.5403L39.4899 31.6697C39.3019 31.5538 39.1139 31.4524 38.9258 31.3365C38.8969 31.3365 38.8824 31.3076 38.8535 31.2931L43.9879 29.3085L50.3083 26.8604L50.2938 26.8749Z",
    fill: "url(#paint15_radial_717_1813)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0242 36.2899C55.9085 36.4492 55.7928 36.6086 55.6771 36.7679L53.3341 32.4511L50.2969 26.874L53.5511 32.2048L56.0242 36.2754V36.2899Z",
    fill: "url(#paint16_radial_717_1813)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1752 21.4716L55.8652 23.8183L50.2969 26.8604L55.6193 23.6011L59.6834 21.124C59.8425 21.2398 60.0016 21.3557 60.1607 21.4716H60.1752Z",
    fill: "url(#paint17_radial_717_1813)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2957 26.8745L47.0415 21.5437L44.5684 17.4732C44.6841 17.3138 44.7998 17.1545 44.9155 16.9951L47.2585 21.3119L50.2957 26.889V26.8745Z",
    fill: "url(#paint18_radial_717_1813)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2955 26.874L44.9731 30.1334L40.9089 32.6104C40.7498 32.4946 40.5907 32.3787 40.4316 32.2628L44.7416 29.9161L50.3099 26.874H50.2955Z",
    fill: "url(#paint19_radial_717_1813)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9479 35.1455C56.9479 35.1455 56.919 35.1745 56.9046 35.1889C56.8033 35.3048 56.7021 35.4352 56.6008 35.5511L53.8962 31.8282L50.2949 26.874L54.0987 31.5964L56.9479 35.131V35.1455Z",
    fill: "url(#paint20_radial_717_1813)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9583 20.544L55.2413 23.2528L50.2949 26.8598L55.0099 23.05L58.5389 20.1963C58.5389 20.1963 58.5678 20.2253 58.5823 20.2398C58.698 20.3412 58.8281 20.4426 58.9438 20.544H58.9583Z",
    fill: "url(#paint21_radial_717_1813)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2956 26.8745L46.4918 22.1521L43.6426 18.6175C43.6426 18.6175 43.6715 18.5885 43.686 18.574C43.7872 18.4582 43.8884 18.3278 43.9897 18.2119L46.6943 21.9348L50.2956 26.889V26.8745Z",
    fill: "url(#paint22_radial_717_1813)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2954 26.874L45.5804 30.6838L42.0514 33.5375C42.0514 33.5375 42.0225 33.5086 42.0081 33.4941C41.8924 33.3927 41.7622 33.2913 41.6465 33.1899L45.3635 30.481L50.3099 26.874H50.2954Z",
    fill: "url(#paint23_radial_717_1813)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9025 34.1323C57.7723 34.2482 57.6566 34.3785 57.5409 34.4944L54.4458 31.2351L50.2949 26.8604L54.6628 31.0179L57.917 34.1178L57.9025 34.1323Z",
    fill: "url(#paint24_radial_717_1813)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9034 19.6168L54.6492 22.7168L50.2812 26.8743L54.4321 22.4995L57.5272 19.2402C57.643 19.3705 57.7732 19.4864 57.8889 19.6023L57.9034 19.6168Z",
    fill: "url(#paint25_radial_717_1813)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2959 26.8745L45.928 22.717L42.6738 19.617C42.804 19.5011 42.9197 19.3707 43.0354 19.2549L46.1305 22.5142L50.2814 26.889L50.2959 26.8745Z",
    fill: "url(#paint26_radial_717_1813)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2951 26.874L46.1442 31.2488L43.0491 34.5081C42.9334 34.3777 42.8032 34.2618 42.6875 34.146L45.9417 31.046L50.3095 26.8885L50.2951 26.874Z",
    fill: "url(#paint27_radial_717_1813)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9595 33.2046C58.8293 33.306 58.7136 33.4074 58.5979 33.5088C58.5979 33.5088 58.569 33.5378 58.5545 33.5523L55.0255 30.6985L50.3105 26.8887L55.2569 30.4957L58.9739 33.2046H58.9595Z",
    fill: "url(#paint28_radial_717_1813)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9499 18.6027L54.1007 22.1372L50.2969 26.8596L53.8982 21.9055L56.6028 18.1826C56.704 18.3129 56.8053 18.4288 56.9065 18.5447C56.9065 18.5447 56.9354 18.5737 56.9499 18.5882V18.6027Z",
    fill: "url(#paint29_radial_717_1813)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2962 26.8745L45.3498 23.2675L41.6328 20.5586C41.763 20.4572 41.8787 20.3558 41.9944 20.2544C41.9944 20.2544 42.0233 20.2254 42.0378 20.2109L45.5668 23.0647L50.2817 26.8745H50.2962Z",
    fill: "url(#paint30_radial_717_1813)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2956 26.874L46.6943 31.8282L43.9897 35.5511C43.8884 35.4207 43.7872 35.3048 43.686 35.1889C43.686 35.1889 43.657 35.1599 43.6426 35.1454L46.4918 31.6109L50.2956 26.8885V26.874Z",
    fill: "url(#paint31_radial_717_1813)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1724 32.2775C60.0133 32.3934 59.8542 32.5093 59.6951 32.6252L55.631 30.1481L50.3086 26.8887L55.8769 29.9308L60.1869 32.2775H60.1724Z",
    fill: "url(#paint32_radial_717_1813)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0223 17.4583L53.5491 21.5288L50.2949 26.8597L53.3322 21.2826L55.6752 16.9658C55.7909 17.1251 55.9066 17.2845 56.0223 17.4438V17.4583Z",
    fill: "url(#paint33_radial_717_1813)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2943 26.8742L44.726 23.8321L40.416 21.4854C40.5751 21.3695 40.7342 21.2536 40.8933 21.1377L44.9574 23.6148L50.2798 26.8742H50.2943Z",
    fill: "url(#paint34_radial_717_1813)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2957 26.874L47.2585 32.4511L44.9155 36.7679C44.7998 36.6086 44.6841 36.4492 44.5684 36.2899L47.0415 32.2193L50.2957 26.8885V26.874Z",
    fill: "url(#paint35_radial_717_1813)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7352 31.3069C61.7063 31.3069 61.6918 31.3359 61.6629 31.3504C61.4749 31.4518 61.2869 31.5677 61.0988 31.6835L56.3116 29.5541L50.2949 26.8887L56.6153 29.3368L61.7497 31.3214L61.7352 31.3069Z",
    fill: "url(#paint36_radial_717_1813)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0822 16.0533L52.9561 20.8481L50.2949 26.8743L52.7392 20.5439L54.7206 15.4014C54.7206 15.4304 54.7495 15.4448 54.764 15.4738C54.8653 15.6621 54.981 15.8505 55.0967 16.0388L55.0822 16.0533Z",
    fill: "url(#paint37_radial_717_1813)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2946 26.8739L43.9742 24.4258L38.8398 22.4412C38.8688 22.4412 38.8832 22.4122 38.9122 22.3977C39.1002 22.2963 39.2882 22.1804 39.4762 22.0645L44.2635 24.194L50.2801 26.8594L50.2946 26.8739Z",
    fill: "url(#paint38_radial_717_1813)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2939 26.874L47.8497 33.2044L45.8682 38.3469C45.8682 38.3179 45.8393 38.3034 45.8248 38.2745C45.7236 38.0861 45.6079 37.8978 45.4922 37.7095L47.6183 32.9147L50.2795 26.8885L50.2939 26.874Z",
    fill: "url(#paint39_radial_717_1813)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0935 30.2202C63.7464 30.3506 63.3994 30.481 63.0667 30.6403L57.1512 28.902L50.2812 26.874L57.5128 28.6268L64.0791 30.2202H64.0935Z",
    fill: "url(#paint40_radial_717_1813)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0553 14.0833L52.3198 20.0081L50.2949 26.8889L52.045 19.6459L53.6359 13.0693C53.7661 13.417 53.8962 13.7646 54.0553 14.0978V14.0833Z",
    fill: "url(#paint41_radial_717_1813)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2947 26.8738L43.0487 25.121L36.4824 23.5275C36.8295 23.3971 37.1767 23.2668 37.5093 23.1074L43.4102 24.8457L50.2802 26.8738H50.2947Z",
    fill: "url(#paint42_radial_717_1813)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2936 26.8749L48.5436 34.1178L46.9526 40.6944C46.8225 40.3468 46.6923 39.9991 46.5332 39.6659L48.2688 33.7412L50.2936 26.8604V26.8749Z",
    fill: "url(#paint43_radial_717_1813)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1093 29.0036V29.134C69.0535 29.134 68.0267 29.2354 67.0287 29.4237C66.9564 29.4237 66.8696 29.4527 66.7973 29.4672L58.293 28.1345L50.2949 26.8887L58.8281 27.8013L70.1093 29.0181V29.0036Z",
    fill: "url(#paint44_radial_717_1813)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8693 10.3456L51.5387 18.8634L50.2949 26.8741L51.2061 18.3274L52.421 7.02832H52.5512C52.5512 8.0858 52.6524 9.1143 52.8404 10.1139C52.8404 10.2008 52.8694 10.2732 52.8838 10.3601L52.8693 10.3456Z",
    fill: "url(#paint45_radial_717_1813)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2949 26.8742L41.7617 25.9615L30.4805 24.7447V24.6143C31.5363 24.6143 32.5631 24.5129 33.5611 24.3246C33.6334 24.3246 33.7202 24.2957 33.7925 24.2812L42.2968 25.6139L50.2949 26.8597V26.8742Z",
    fill: "url(#paint46_radial_717_1813)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M50.294 26.874L49.3828 35.4207L48.1679 46.7197H48.0377C48.0377 45.6623 47.9365 44.6338 47.7485 43.6487C47.7485 43.5618 47.7195 43.4749 47.7051 43.4025L49.0357 34.8847L50.2795 26.874H50.294Z",
    fill: "url(#paint47_radial_717_1813)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0887 80.7916C39.0887 83.8481 37.0494 84.6303 35.7043 84.6303C33.6795 84.6303 32.4212 83.6887 32.4212 80.7916V73.9688H31.1484V80.8931C31.1484 84.0365 33.0576 85.0795 35.2993 85.0795C37.5411 85.0795 39.4502 83.8916 39.4502 80.7482V73.9688H39.0887V80.7916Z",
    fill: "white"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9347 73.9688H49.6166L46.507 82.9934L43.2383 74.606C43.0937 74.2294 42.7177 73.9688 42.3127 73.9688H40.8809V74.1715C41.3148 74.3018 41.5028 74.6496 41.5028 75.6926V84.9201H41.8065C41.8065 84.9201 41.8065 75.8084 41.8065 74.7219L45.8272 84.9201H46.1165L49.6455 74.5337V84.9201H50.9182V74.9682C50.9182 74.4177 50.4699 73.9688 49.9203 73.9688H49.9347Z",
    fill: "white"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0457 80.7916C60.0457 83.8481 58.0064 84.6303 56.6613 84.6303C54.6365 84.6303 53.3782 83.6887 53.3782 80.7916V73.9688H52.1055V80.8931C52.1055 84.0365 54.0146 85.0795 56.2564 85.0795C58.4981 85.0795 60.4073 83.8916 60.4073 80.7482V73.9688H60.0457V80.7916Z",
    fill: "white"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8211 80.7916C77.8211 83.8481 75.7818 84.6303 74.4367 84.6303C72.4119 84.6303 71.1536 83.6887 71.1536 80.7916V73.9688H69.8809V80.8931C69.8809 84.0365 71.79 85.0795 74.0318 85.0795C76.2735 85.0795 78.1827 83.8916 78.1827 80.7482V73.9688H77.8211V80.7916Z",
    fill: "white"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4357 73.9688H79.3262V84.9055H82.7973C86.2251 84.9055 88.4234 82.8341 88.4234 79.1836C88.4234 76.6486 86.7168 73.9688 82.4357 73.9688ZM82.7684 84.6303H80.6134V74.2585H82.7828C85.3139 74.2585 87.0061 76.3154 87.0061 79.4299C87.0061 82.7037 85.4874 84.6159 82.7539 84.6159L82.7684 84.6303Z",
    fill: "white"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M6.50325 73.9688L6.87929 74.9248L2.84409 84.8912V84.9345C2.82963 84.9345 3.27798 84.9345 3.27798 84.9345L4.91231 80.8785H9.33801L11.0302 84.9345H12.3897L7.89171 73.9833H6.50325V73.9688ZM5.07141 80.4585L7.09624 75.4317L9.13553 80.4585H5.05694H5.07141Z",
    fill: "white"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2667 73.9688H91.8782L92.2543 74.9248L88.2191 84.8912V84.9345C88.2046 84.9345 88.653 84.9345 88.653 84.9345L90.2873 80.8785H94.713L96.4052 84.9345H97.7647L93.2667 73.9833V73.9688ZM90.4464 80.4585L92.4712 75.4317L94.5105 80.4585H90.4319H90.4464Z",
    fill: "white"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5092 84.4276C16.7861 84.5145 16.1786 84.558 15.6869 84.558H14.472V73.9688H13.1992V84.9201H20.0836V84.0219L19.3316 84.1524C18.8398 84.2393 18.2324 84.3261 17.5092 84.413V84.4276Z",
    fill: "white"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2923 82.1677C65.4535 81.4869 64.9039 80.9364 64.6725 80.5453C65.8006 80.4294 66.6973 80.0673 67.3192 79.4734C67.9556 78.865 68.2738 78.0537 68.2738 77.0687C68.2738 76.0836 68.2159 76.3299 68.0858 75.9822C67.9556 75.6345 67.7676 75.3015 67.5072 74.9973C67.2469 74.6931 66.8853 74.4322 66.4225 74.2439C65.9597 74.0556 65.4101 73.9688 64.8026 73.9688H61.5195V84.9201H62.8067V80.5743H63.8915C64.0506 80.5743 64.2097 80.5744 64.3688 80.5599C65.6994 83.008 66.8709 84.4565 67.8688 84.8766H67.8833L68.6788 83.6888H68.6498C67.9267 83.3701 67.1312 82.8631 66.2634 82.1533L66.2923 82.1677ZM63.9059 80.2266H62.8212V74.2294H64.1952C64.6869 74.2294 65.1064 74.3164 65.468 74.5047C65.8295 74.6931 66.1188 74.9392 66.3213 75.2579C66.5238 75.5766 66.6829 75.9098 66.7841 76.2719C66.8853 76.6341 66.9432 77.0253 66.9432 77.4164C66.9432 78.3435 66.6829 78.9664 66.1622 79.4734C65.6415 79.9659 64.8894 80.2266 63.9204 80.2266H63.9059Z",
    fill: "white"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4854 73.9688V74.8669L23.2375 74.7365C23.7292 74.6496 24.3367 74.5627 25.0598 74.4758C25.783 74.3889 26.3904 74.3454 26.8822 74.3454H28.2995L21.5742 84.7318V84.9345H29.6446V84.0365L28.8925 84.1668C28.4008 84.2537 27.7933 84.3407 27.0702 84.4276C26.347 84.5145 25.7396 84.558 25.2478 84.558H23.2085L29.9773 74.1715V73.9688H22.4854Z",
    fill: "white"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0699 77.0107H20.6195L21.1257 73.9688H19.5781L20.0699 77.0107Z",
    fill: "white"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1728 59.0917C33.0012 59.0917 32.1913 59.2365 31.8008 59.6421C31.3814 60.0188 31.3814 60.4678 31.3814 61.6557H31.6996C31.8008 60.323 32.6541 59.9173 33.8256 59.9173C34.9971 59.9173 36.5592 61.0762 36.5592 62.8725C36.5592 64.6687 36.212 64.5238 35.8071 65.1032C35.4021 65.6827 34.65 66.0014 33.8546 66.0014H31.1934V66.6243H34.1728C35.4021 66.6243 36.3856 66.1898 37.0509 65.5234C37.7307 64.8426 38.1067 63.9009 38.1067 62.8579C38.1067 61.8149 37.7307 60.8734 37.0509 60.1781C36.3711 59.4973 35.4021 59.0771 34.1728 59.0771V59.0917Z",
    fill: "white"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0181 63.1033C74.0181 63.451 73.9892 63.7986 73.9169 64.1318C73.7578 64.8126 73.4974 65.1168 73.1937 65.4355C72.7888 65.8411 71.9644 66.015 71.4437 66.015H58.803V59.0762H57.2554V66.5944C57.2554 67.1014 57.1976 67.6809 56.9951 68.2748C56.7637 68.8832 56.3587 69.4626 55.6211 69.8972L55.8236 70.0566C56.2285 69.9551 56.7203 69.7523 57.4434 69.2453C58.1377 68.7528 58.7596 67.9561 58.7885 66.6379H72.4416C73.3384 66.6379 74.0904 66.2902 74.669 65.6818C75.2475 65.0734 75.5657 64.2187 75.5657 63.1468V55.7734H74.0181V63.1033Z",
    fill: "white"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M77.793 55.7734V66.6379H79.3405V55.7879L77.793 55.7734Z",
    fill: "white"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8633 59.2654C49.4893 59.2654 48.3034 59.6856 47.5802 60.4244C46.698 61.2211 46.3219 62.206 46.3219 63.5387V63.8429C46.2496 64.7266 46.0471 65.277 45.7145 65.5957C45.3963 65.9144 44.9624 66.0159 44.4707 66.0159H41.4768V59.0771H39.9292V66.5954C39.9292 67.1024 39.8714 67.6817 39.6689 68.2757C39.4375 68.8841 39.0325 69.4635 38.2949 69.8981L38.4974 70.0574C38.9024 69.956 39.3941 69.7532 40.1173 69.2462C40.8115 68.7537 41.4334 67.9569 41.4623 66.6387H45.136C45.3818 66.6098 45.6132 66.5663 45.8446 66.4794C46.2496 66.349 46.5678 66.0883 46.7992 65.6537C46.9728 65.9724 47.2042 66.3055 47.4934 66.6098C48.2021 67.3051 49.3013 67.7831 50.603 67.7831C51.9047 67.7831 53.163 67.4066 53.9584 66.6243C54.7539 65.9 55.1878 64.8425 55.1878 63.5387C55.1878 62.235 54.7828 61.2066 54.0163 60.4244C53.3221 59.729 52.165 59.2509 50.8633 59.2509V59.2654ZM52.7146 66.1462C52.2663 66.7691 51.6443 67.0733 50.8633 67.0733C50.0823 67.0733 49.4893 66.7257 49.0121 66.0159C48.5348 65.2916 48.2311 64.5527 48.2311 63.278C48.2311 62.0032 48.4769 61.4672 48.9108 60.8443C49.3592 60.2359 49.9811 59.9318 50.791 59.9318C51.601 59.9318 52.165 60.2794 52.6423 61.0182C53.1196 61.7135 53.3221 62.4957 53.3221 63.785C53.3221 65.0742 53.1919 65.5378 52.7146 66.1462Z",
    fill: "white"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5865 60.4092C21.8199 61.0466 21.2703 61.9303 21.2559 63.0022C21.2848 64.0742 21.8199 64.9578 22.5865 65.5952C23.3675 66.2471 24.3799 66.6527 25.3344 66.6527H29.1238V59.3662H25.3344C24.3799 59.3662 23.3675 59.7718 22.5865 60.4237V60.4092ZM27.5618 66.0153H25.1753C23.7146 66.0153 22.8034 64.6826 22.7889 63.0022C22.8034 61.3218 23.7001 59.9891 25.1753 59.9891H27.5618V66.0298V66.0153Z",
    fill: "white"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3756 57.8741C26.9108 57.8741 27.3447 57.4395 27.3447 56.9325C27.3447 56.4255 26.9108 55.9619 26.3756 55.9619C25.8405 55.9619 25.4355 56.3965 25.4355 56.9325C25.4355 57.4685 25.8694 57.8741 26.3756 57.8741Z",
    fill: "white"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0182 57.8741C24.5534 57.8741 24.9583 57.4395 24.9583 56.9325C24.9583 56.4255 24.5534 55.9619 24.0182 55.9619C23.4831 55.9619 23.0781 56.3965 23.0781 56.9325C23.0781 57.4685 23.4831 57.8741 24.0182 57.8741Z",
    fill: "white"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9928 57.8741C58.528 57.8741 58.9619 57.4395 58.9619 56.9325C58.9619 56.4255 58.528 55.9619 57.9928 55.9619C57.4577 55.9619 57.0527 56.3965 57.0527 56.9325C57.0527 57.4685 57.4866 57.8741 57.9928 57.8741Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_717_1813",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.4258 26.9029) scale(19.0913 19.1215)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6E8E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6C0B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#DA9F8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D18871"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#CB7A60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#CA765B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_717_1813",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.4251 26.9035) scale(13.6098 13.6312)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#F6E8E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6C0B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DA9F8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#D18871"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CB7A60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA765B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_717_1813",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.4258 -32.1555) scale(13.6097 13.6313)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#F6E8E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6C0B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DA9F8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#D18871"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CB7A60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA765B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_717_1813",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.4255 -32.1555) scale(13.6097 13.6312)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#F6E8E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6C0B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DA9F8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#D18871"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CB7A60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA765B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_717_1813",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-27.7323 26.9029) scale(13.6097 13.6313)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#F6E8E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6C0B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DA9F8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#D18871"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CB7A60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA765B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_717_1813",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.4251 26.9034) scale(13.6098 13.6313)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#F6E8E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6C0B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DA9F8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#D18871"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CB7A60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA765B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_717_1813",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.4253 26.9032) scale(13.6097 13.6313)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#F6E8E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6C0B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DA9F8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#D18871"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CB7A60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA765B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_717_1813",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-27.733 26.9038) scale(13.6097 13.6313)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#F6E8E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6C0B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DA9F8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#D18871"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CB7A60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA765B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_717_1813",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.4251 26.903) scale(13.6098 13.6313)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#F6E8E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6C0B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DA9F8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#D18871"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CB7A60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA765B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_717_1813",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-27.7334 26.9037) scale(13.6098 13.6313)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#F6E8E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6C0B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DA9F8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#D18871"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CB7A60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA765B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_717_1813",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.4238 26.9033) scale(13.6098 13.6313)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#F6E8E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6C0B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DA9F8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#D18871"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CB7A60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA765B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_717_1813",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.4248 26.903) scale(13.6098 13.6313)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#F6E8E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6C0B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DA9F8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#D18871"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CB7A60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA765B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_717_1813",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-27.7323 26.9038) scale(13.6097 13.6313)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#F6E8E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6C0B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DA9F8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#D18871"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CB7A60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA765B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_717_1813",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-27.7324 26.9029) scale(13.6097 13.6313)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#F6E8E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6C0B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DA9F8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#D18871"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CB7A60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA765B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_717_1813",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.4233 26.9034) scale(13.6097 13.6313)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#F6E8E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6C0B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DA9F8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#D18871"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CB7A60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA765B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_717_1813",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.424 26.9038) scale(13.6097 13.6313)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#F6E8E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6C0B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DA9F8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#D18871"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CB7A60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA765B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_717_1813",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-27.7313 26.903) scale(13.6097 13.6313)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#F6E8E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6C0B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DA9F8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#D18871"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CB7A60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA765B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_717_1813",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.427 26.9039) scale(13.6097 13.6313)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#F6E8E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6C0B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DA9F8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#D18871"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CB7A60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA765B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_717_1813",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.4259 26.9035) scale(13.6098 13.6313)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#F6E8E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6C0B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DA9F8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#D18871"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CB7A60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA765B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_717_1813",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.4256 26.903) scale(13.6098 13.6313)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#F6E8E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6C0B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DA9F8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#D18871"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CB7A60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA765B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_717_1813",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-27.7334 26.903) scale(13.6098 13.6313)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#F6E8E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6C0B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DA9F8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#D18871"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CB7A60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA765B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_717_1813",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-27.7334 26.9033) scale(13.6098 13.6313)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#F6E8E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6C0B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DA9F8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#D18871"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CB7A60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA765B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_717_1813",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.4258 26.9035) scale(13.6098 13.6313)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#F6E8E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6C0B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DA9F8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#D18871"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CB7A60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA765B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_717_1813",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-27.7328 26.903) scale(13.6097 13.6313)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#F6E8E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6C0B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DA9F8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#D18871"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CB7A60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA765B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_717_1813",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-27.7334 26.9038) scale(13.6098 13.6313)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#F6E8E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6C0B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DA9F8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#D18871"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CB7A60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA765B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_717_1813",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-27.7325 26.9032) scale(13.6097 13.6313)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#F6E8E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6C0B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DA9F8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#D18871"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CB7A60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA765B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_717_1813",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.426 26.9034) scale(13.6098 13.6313)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#F6E8E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6C0B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DA9F8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#D18871"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CB7A60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA765B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_717_1813",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.4252 26.903) scale(13.6097 13.6313)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#F6E8E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6C0B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DA9F8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#D18871"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CB7A60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA765B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_717_1813",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-27.7321 26.9032) scale(13.6098 13.6313)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#F6E8E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6C0B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DA9F8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#D18871"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CB7A60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA765B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_radial_717_1813",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-27.7314 26.9031) scale(13.6098 13.6313)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#F6E8E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6C0B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DA9F8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#D18871"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CB7A60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA765B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial_717_1813",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-27.7321 26.9034) scale(13.6097 13.6313)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#F6E8E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6C0B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DA9F8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#D18871"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CB7A60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA765B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_radial_717_1813",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.4258 26.9029) scale(13.6098 13.6313)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#F6E8E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6C0B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DA9F8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#D18871"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CB7A60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA765B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint32_radial_717_1813",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.4243 26.9032) scale(13.6098 13.6313)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#F6E8E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6C0B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DA9F8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#D18871"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CB7A60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA765B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint33_radial_717_1813",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-27.7333 26.9031) scale(13.6097 13.6313)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#F6E8E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6C0B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DA9F8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#D18871"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CB7A60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA765B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint34_radial_717_1813",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.4245 26.9031) scale(13.6097 13.6313)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#F6E8E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6C0B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DA9F8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#D18871"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CB7A60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA765B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint35_radial_717_1813",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.4259 26.903) scale(13.6097 13.6313)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#F6E8E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6C0B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DA9F8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#D18871"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CB7A60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA765B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint36_radial_717_1813",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-27.7334 26.9032) scale(13.6098 13.6313)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#F6E8E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6C0B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DA9F8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#D18871"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CB7A60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA765B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint37_radial_717_1813",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-27.7334 26.9032) scale(13.6098 13.6313)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#F6E8E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6C0B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DA9F8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#D18871"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CB7A60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA765B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint38_radial_717_1813",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.4248 26.9028) scale(13.6098 13.6313)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#F6E8E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6C0B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DA9F8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#D18871"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CB7A60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA765B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint39_radial_717_1813",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.4241 26.903) scale(13.6098 13.6313)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#F6E8E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6C0B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DA9F8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#D18871"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CB7A60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA765B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint40_radial_717_1813",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-27.7325 26.9029) scale(13.6098 13.6313)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#F6E8E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6C0B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DA9F8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#D18871"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CB7A60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA765B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint41_radial_717_1813",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.4251 26.9034) scale(13.6098 13.6313)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#F6E8E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6C0B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DA9F8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#D18871"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CB7A60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA765B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint42_radial_717_1813",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.4248 26.9027) scale(13.6098 13.6313)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#F6E8E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6C0B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DA9F8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#D18871"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CB7A60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA765B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint43_radial_717_1813",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.4238 26.9038) scale(13.6098 13.6313)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#F6E8E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6C0B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DA9F8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#D18871"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CB7A60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA765B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint44_radial_717_1813",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.4251 26.9032) scale(13.6098 13.6313)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#F6E8E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6C0B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DA9F8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#D18871"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CB7A60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA765B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint45_radial_717_1813",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-27.7335 26.9031) scale(13.6098 13.6313)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#F6E8E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6C0B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DA9F8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#D18871"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CB7A60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA765B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint46_radial_717_1813",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-27.7334 26.9031) scale(13.6098 13.6313)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#F6E8E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6C0B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DA9F8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#D18871"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CB7A60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA765B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint47_radial_717_1813",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.4241 26.903) scale(13.6098 13.6313)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#F6E8E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6C0B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DA9F8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#D18871"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CB7A60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA765B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlZumuruda);
export default __webpack_public_path__ + "static/media/al_zumuruda.c2c547d97429fef3a55ce053a4a21b3d.svg";
export { ForwardRef as ReactComponent };